/*
*@Author: longfei
*@Date: 2020-02-28 10:25:45
 * @Last Modified by: lyf
 * @Last Modified time: 2020-04-16 09:03:43
*/
// 第三方登录
let mixin = {
  data() {
    return {
      timeInteral: false
    }
  },
  mounted() {
    console.log('aaaa')
    let url = window.location.href
    if (url.split('&')[2] && url.split('&')[2].split('=')[1] == 1) {
      return
    }
    this.fbInit()
    this.twInit()
  },
  methods: {
    // facebook初始化
    fbInit() {
      console.log('初始化FB')
      console.log(this.facebookAPIKey)
      let that = this
      window.fbAsyncInit = function () {
        FB.init({
          appId: that.facebookAPIKey,
          cookie: true,
          xfbml: true,
          version: 'v6.0'
        });
        FB.AppEvents.logPageView();
      };
      (function (d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) { return; }
        js = d.createElement(s); js.id = id;
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));
      setTimeout(() => {
        if (window.localStorage.getItem('loginKey')) {
          that.fbLogin();
        }
      }, 2000);
    },
    // twitter初始化
    twInit() {
      console.log('初始化TW')
      setTimeout(() => {
        if (window.localStorage.getItem('loginKey')) {
          that.twLogin();
        }
      }, 2000);
      hello.init({
        'twitter': this.twitterAPIKey 
      }, {
          scope: 'friends, photos, email'
      })
    },
    // facebook登录
    fbLogin() {
      let that = this
      FB.getLoginStatus(function (response) {
        // 初始化的时候看一下not_authorized 是不是这个状态
        if (response.status !== 'connected' ) {
          if (response.status == 'not_authorized') {
            window.localStorage.setItem('loginKey', true);
          } else {
            $("#Modal").css({ "opacity": 1, "display": "block", "visibility": "visible", "background": "rgba(0,0,0,0.5)", "padding- right": "17px" });
            $("#Modal").modal("show")
            that.ModalFlag = 10
          }
          FB.login(function (res) {
            // 获取登录状态
            that.statusChangeCallback(res);
            window.localStorage.removeItem('loginKey');
          }, { scope: 'public_profile, email', enable_profile_selector : true });
        } else {
          $("#Modal").css({ "opacity": 1, "display": "block", "visibility": "visible", "background": "rgba(0,0,0,0.5)", "padding- right": "17px" });
          $("#Modal").modal("show")
          that.ModalFlag = 10
          // 获取登录状态
          that.statusChangeCallback(response);
          window.localStorage.removeItem('loginKey');
        }
      });
    },
    // fb获取登录状态
    statusChangeCallback() {
      let that = this;
      // https://developers.facebook.com/docs/facebook-login/permissions#reference-default
      FB.api('/me', { fields: 'id, name, email, middle_name, first_name, last_name, picture, short_name, name_format' }, function (response) {
        console.log(response)
        if (!response.error ) {
          let data = {
            account: response.email || '',
            first_name: response.first_name,
            last_name: response.last_name,
            id: response.id,
            login_source: 'facebook',
            source: 9
          }
          that.getMediaLogin(data);
        } else {
          that.ModalFlag = 1
          console.log('sss')
        }
      })
      
    },
    // twitter登录
    twLogin() {
      let that = this;
      window.localStorage.setItem('loginKey', true);
      this.ModalFlag = 10
      hello('twitter').login({ scope: 'email' }).then(function (res) {
        console.log(res);
      }, function (e) {
        window.localStorage.removeItem('loginKey');
        that.ModalFlag = 1
      })
      // 监听登录事件,登录成功返回的auth里面包含基本用户信息和accessToken信息
      hello.on('auth.login', function (auth) {
        // 登录完成后获取当前登录用户完整信息
        hello(auth.network).api('me', { 'include_email': true }).then(function (response) {
          window.localStorage.removeItem('loginKey');
          let data = {
            account: response.email,
            first_name: response.first_name,
            last_name: response.last_name,
            id: response.id,
            login_source: 'twitter',
            source: 10
          }
          that.getMediaLogin(data);
        }).catch(err => {
          window.localStorage.removeItem('loginKey');
          that.ModalFlag = 1
          alert(JSON.stringify(err))
        });
      });
    },
  }
}